
    import HeadingWave from "@/features/shared/components/HeadingWave.vue";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import userInfo from "@/features/shared/components/UserInfo";
    import {NavigationGuardNext} from "vue-router/types/router";
    import ApplicationTypeTable from "../components/ApplicationTypeTable.vue";
    interface Props {
        seafarerId: string;
    }

    @Component({
        components: {
            HeadingWave,
            SectionPageHeading,
            ApplicationTypeTable
        },
        beforeRouteEnter (to, from, next: NavigationGuardNext<NewApplication>) {
            const props = to.meta!.props as Props;
            props.seafarerId = to.params.seafarerId || userInfo.seafarerId;
            if (!props.seafarerId)
                next(new Error("No seafarer."));
            next();
        }
    })
    export default class NewApplication extends Vue implements Props {
        @Prop({ required: true })
        seafarerId!: string;
    }
